const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Build two parallel arrays of course days between startDate and endDate,
 * excluding weekends.
 *
 * startDate is a UTC datetime string from the API (e.g. "2024-01-15T00:00:00Z").
 * The backend stores deadlines as UTC midnight DateTimeField values, so
 * toISOString().slice(0, 10) correctly matches the backend's date.isoformat() output.
 *
 * @param {string} startDate - UTC datetime string as returned by the API
 * @param {string} endDate   - YYYY-MM-DD string (exclusive upper bound)
 * @returns {{ iso: string[], display: string[] }}
 *   iso:     YYYY-MM-DD strings for comparison against backend date_iso field
 *   display: human-readable strings like "15 Jan" for table headers
 */
export function getCourseDays(startDate, endDate) {
  const iso = [];
  const display = [];

  const dateMove = new Date(startDate);

  while (true) {
    const utcISO = dateMove.toISOString().slice(0, 10);

    if (utcISO >= endDate) break;

    const dayOfWeek = dateMove.getUTCDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      iso.push(utcISO);
      display.push(`${dateMove.getUTCDate()} ${MONTH_NAMES[dateMove.getUTCMonth()]}`);
    }

    dateMove.setUTCDate(dateMove.getUTCDate() + 1);
  }

  return { iso, display };
}
